/* eslint-disable @next/next/no-img-element */
import React from "react";
import st from "./videoCover.module.scss";

type Props = {
  openVideoModal: () => void;
};

const VideoCover = (props: Props) => {
  return (
    <div className={st.videoResponsive}>
      <div
        onClick={props.openVideoModal}
        className={st.modalOpenImagesContainer}
      >
        <img
          src="https://www.datocms-assets.com/74813/1668796278-youtube-video-frame.png"
          alt="play-youtube-cover"
        />
        <img
          width={100}
          height={100}
          className={st.playYoutubeButton}
          src="https://www.datocms-assets.com/74813/1668796271-play-svg.png"
          alt="play-youtube"
        />
      </div>
    </div>
  );
};

export default VideoCover;
